import { render, staticRenderFns } from "./CompanyEditor.vue?vue&type=template&id=49f5f1aa"
import script from "./CompanyEditor.vue?vue&type=script&lang=ts"
export * from "./CompanyEditor.vue?vue&type=script&lang=ts"
import style0 from "./CompanyEditor.vue?vue&type=style&index=0&id=49f5f1aa&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports